import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import AllPromoCodesData from "./all-promo-codes-data";
import AllPromoCodesForm from "./all-promo-codes-form";

const AllPromoCodes = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <AllPromoCodesForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AllPromoCodesData />
    </React.Fragment>
  );
});
export default AllPromoCodes;
